// src/SignUpScreen.js
import React, { useState } from 'react';
import axios from 'axios';
import styles from './ChatApp.module.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SignUpScreen = ({ onNavigateToConfirm, onNavigateToLogin, onNavigateToLanding }) => { 
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [password, setPassword] = useState('');
    
    // --- ERP State ---
    const [erpStatus, setErpStatus] = useState(''); // 'yes' or 'no'
    const [erpSelection, setErpSelection] = useState(''); // 'QuickBooks', 'NetSuite', etc.
    const [erpOther, setErpOther] = useState('');
    const [interestInLite, setInterestInLite] = useState(''); // 'yes' or 'no'
    
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const KNOWN_ERPS = ["QuickBooks", "NetSuite", "SAP Business One", "Sage", "Odoo", "Other"];

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setIsLoading(true);

        // Build the structured ERP info
        const erp_info = {
            status: erpStatus || null,
            selection: erpStatus === 'yes' ? erpSelection : null,
            other_name: erpSelection === 'Other' ? erpOther : null,
            interest_in_lite: erpStatus === 'no' ? interestInLite : null,
        };

        try {
            // Address fields are removed from the payload
            await axios.post(`${API_BASE_URL}/signup`, { 
                name, 
                email, 
                password, 
                company_name: companyName, 
                erp_info: erp_info
            });

            setMessage('Success! Please check your email to confirm your account. Redirecting...');
            
            setTimeout(() => {
                onNavigateToConfirm(email); 
            }, 2000);

        } catch (err) {
            setError(err.response?.data?.detail || 'An error occurred during sign-up.');
            setIsLoading(false);
        }
    };

    return (
        <div className={styles.loginContainer}>
            <form className={styles.loginBox} onSubmit={handleSubmit}>
                <div className={styles.loginLogo}>AirGrocer AI</div>
                <h2>Distributor Sign-up</h2>
                
                {message && <div className={styles.adminSuccess} style={{textAlign: 'left', marginBottom: '15px'}}>{message}</div>}
                {error && <div className={styles.adminError} style={{textAlign: 'left', marginBottom: '15px'}}>{error}</div>}

                <input
                    type="text"
                    placeholder="Your Full Name"
                    className={styles.loginInput}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    disabled={isLoading}
                />
                <input
                    type="text"
                    placeholder="Company Name"
                    className={styles.loginInput}
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    required
                    disabled={isLoading}
                />
                <input
                    type="email"
                    placeholder="Work Email"
                    className={styles.loginInput}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isLoading}
                />
                <input
                    type="password"
                    placeholder="Password"
                    className={styles.loginInput}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={isLoading}
                />

                {/* --- (ERP FORM FIELDS) --- */}
                
                <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Do you currently use an ERP system?</label>
                    <div className={styles.segmentedControl}>
                        <button
                            type="button"
                            className={`${styles.segmentedButton} ${erpStatus === 'yes' ? styles.segmentedButtonActive : ''}`}
                            onClick={() => setErpStatus('yes')}
                            disabled={isLoading}
                        >
                            Yes
                        </button>
                        <button
                            type="button"
                            className={`${styles.segmentedButton} ${erpStatus === 'no' ? styles.segmentedButtonActive : ''}`}
                            onClick={() => setErpStatus('no')}
                            disabled={isLoading}
                        >
                            No
                        </button>
                    </div>
                </div>

                {erpStatus === 'yes' && (
                    <div className={`${styles.formGroup} ${styles.formSubGroup}`}>
                        <label className={styles.formLabel} htmlFor="erpSelection">Which ERP do you use?</label>
                        <select
                            id="erpSelection"
                            value={erpSelection}
                            onChange={(e) => setErpSelection(e.target.value)}
                            className={styles.loginInput}
                            disabled={isLoading}
                        >
                            <option value="">-- Select one --</option>
                            {KNOWN_ERPS.map(erp => (
                                <option key={erp} value={erp}>{erp}</option>
                            ))}
                        </select>
                        
                        {erpSelection === 'Other' && (
                            <div style={{marginTop: '10px'}}>
                                <input
                                    id="erpOther"
                                    type="text"
                                    value={erpOther}
                                    onChange={(e) => setErpOther(e.target.value)}
                                    placeholder="Please specify your ERP"
                                    className={styles.loginInput}
                                    style={{marginBottom: 0}} 
                                    disabled={isLoading}
                                />
                            </div>
                        )}
                    </div>
                )}
                
                {erpStatus === 'no' && (
                     <div className={`${styles.formGroup} ${styles.formSubGroup}`}>
                        <label className={styles.formLabel}>Are you interested in our AI ERP Lite?</label>
                        <div className={styles.segmentedControl}>
                            <button
                                type="button"
                                className={`${styles.segmentedButton} ${interestInLite === 'yes' ? styles.segmentedButtonActive : ''}`}
                                onClick={() => setInterestInLite('yes')}
                                disabled={isLoading}
                            >
                                Yes, tell me more
                            </button>
                            <button
                                type="button"
                                className={`${styles.segmentedButton} ${interestInLite === 'no' ? styles.segmentedButtonActive : ''}`}
                                onClick={() => setInterestInLite('no')}
                                disabled={isLoading}
                            >
                                No, not now
                            </button>
                        </div>
                    </div>
                )}
                {/* --- (END OF ERP FIELDS) --- */}


                <button type="submit" className={styles.loginButton} disabled={isLoading}>
                    {isLoading ? 'Creating Account...' : 'Sign Up'}
                </button>
                
                <div className={styles.signUpLink}>
                    Already have an account?{' '}
                    <button type="button" onClick={onNavigateToLogin} className={styles.linkButton}>
                        Login
                    </button>
                </div>
                <div className={styles.signUpLink} style={{marginTop: '10px'}}>
                    <button type="button" onClick={onNavigateToLanding} className={styles.linkButton}>
                        &larr; Back to Home
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SignUpScreen;